module.exports = __webpack_public_path__ + "img/1@2x.3afc89c0.png";